<ng-container>
	<div [style]="{padding:'0!important'}">

		<div>
			<h2>{{title}}</h2>
			<div>
				{{
				otpResponse?.message
				|| 'We’ve just sent you a 6 digit code. Check your messages and enter it here.'
				}}
			</div>
		</div>
		<form (ngSubmit)="validateOTP()" [formGroup]="form" class="login-form" nz-form>
			<app-floating-label-input [suffixType]="'eye'" [controlDef]="otpControl" label="Enter OTP"
				placeHolder="Enter OTP">
			</app-floating-label-input>
			<nz-alert [nzMessage]="loanDesc" class="m-t-10 m-b-10" nzShowIcon nzType="info">
				<ng-template #loanDesc>
					Didn't get the code? dial <a
						[href]="'tel:'+otpResponse?.ussdCode"><strong>{{otpResponse?.ussdCode}}</strong></a>
				</ng-template>
			</nz-alert>

			<ng-container *ngIf="errorMessage">
				<app-custom-error-display [errorDescription]="errorMessage" [errorMessage]="'OTP Failed'">
				</app-custom-error-display>
			</ng-container>

			<div class="m-t-20" nz-row nzAlign="middle" nzJustify="space-between">
				<div>

				</div>
				<div nz-row nzAlign="middle">
					<div class="cta-secondary-link">
						<a (click)="modal.destroy()">Close</a>
					</div>
					<div class="m-l-48">
						<div class="button-size-124">
							<app-custom-submit-button [block]="true" [disabled]="!form.valid" [submitting]="submitting"
								name="{{'moniepoint.submit'|translate}}">
							</app-custom-submit-button>
						</div>
					</div>
				</div>
			</div>
		</form>

	</div>
</ng-container>